import { render } from "./PRO_Clase.vue?vue&type=template&id=eb9f5fca&ts=true"
import script from "./PRO_Clase.vue?vue&type=script&lang=ts"
export * from "./PRO_Clase.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__